export default [
  {
    path: '/main/shippingmethodtransportation',
    meta: {
      tag: 'list_shipping_method_transportation',
      name: 'Formas de Envio de Transporte',
      breadcrumb: 'Formas de Envio de Transporte'
    },
    component: () => import(/* webpackChunkName: "shipping-method-transportation-list" */ '@/views/main/settings/test-registers/shippingmethodtransportation/Index.vue'),
    children: [
      {
        path: '',
        name: 'listshippingmethodtransportation',
        meta: {
          tag: 'list_shipping_method_transportation',
          menu: 'settings',
          name: 'Formas de Envio de Transporte'
        },
        component: () => import(/* webpackChunkName: "shipping-method-transportation-list" */ '@/views/main/settings/test-registers/shippingmethodtransportation/List.vue')
      },
      {
        path: '/main/shippingmethodtransportation/add',
        name: 'addshippingmethodtransportation',
        meta: {
          tag: 'add_shipping_method_transportation',
          menu: 'settings',
          name: 'Adicionar | Forma de Envio de Transporte',
          breadcrumb: 'Adicionar Forma de Envio de Transporte'
        },
        component: () => import(/* webpackChunkName: "shipping-method-transportation-add" */ '@/views/main/settings/test-registers/shippingmethodtransportation/Add.vue')
      },
      {
        path: '/main/shippingmethodtransportation/:id',
        name: 'editshippingmethodtransportation',
        meta: {
          tag: 'edit_shipping_method_transportation',
          menu: 'settings',
          name: 'Editar | Forma de Envio de Transporte',
          breadcrumb: 'Editar Forma de Envio de Transporte'
        },
        component: () => import(/* webpackChunkName: "shipping-method-transportation-edit" */ '@/views/main/settings/test-registers/shippingmethodtransportation/Edit.vue')
      }
    ]
  },
]
